import React from 'react'
import KnowledgeCenter from '../advanced-screener/knowledge-center'
import QuickIdeas from './quick-ideas'
import QuickScreener from './quick-screener'
import RecentSearches from '../advanced-screener/recent-searches'
import SavedSearches from '../advanced-screener/saved-searches'
import YieldCharts from './yield-charts/yield-charts'
import YieldGrids from './yield-grids/yield-grids'
import { trackPage } from '../twd'
export default () => {
    trackPage('overview')

    return (
    <React.Fragment>

    <div className="container" style={{padding:0}}>
    <div className="row">
    <div className="col-md-12">
    <YieldGrids />
    </div>
    </div>
    </div>

    <div style={{backgroundColor:"#f6f6f6"}}>
    <div className="container">
    <div className="row vertical-offset-sm">

        <div className="col-md-8 col-xs-12">
            <QuickIdeas />
            <YieldCharts />
        </div>

        <div className="col-md-4 col-xs-12">
            <QuickScreener />
            <RecentSearches dataName="overview-recent-searches" />
            <SavedSearches  dataName="overview-saved-searches" />
            <KnowledgeCenter  dataName="overview-knowledge-center" />
        </div>
    </div>
    </div>
    </div>
    </React.Fragment>)
}


// WEBPACK FOOTER //
// ./src/overview/overview.js